<template>
    <footer class="footer">
        <div class="container">
            <div class="footer-server clearfix">
                <dl class="footer-font-padding">
                    <dt>关于我们</dt>
                    <dd>
 我們擁有一支優秀的服務團隊，秉承質量、安全、服務、效率，一致性和完美的理念，服務於廣大用戶，致力 於海外倉儲、轉運清關、全球取件、集運派送服務爲主。 給顧客、企業帶來高效實際的價值。</dd>
                    <dd class="footer-link">
                        <router-link to="/product" >我们的服务</router-link>
                        <router-link to="/job" >加入我们</router-link>
                    </dd>
                </dl>
                <dl class="footer-search">
                    <dd>
                        <input type="text" placeholder="请输入您的单号进行追踪" v-model="footcourier" >
                        <a href="javascript:;"  @click="getfootTracking()"><img :src="souimg" alt=""></a>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="copyright">
            <div class="container">
                <div>Copyright © 2021 www.sugouex.com.INC. Powered by 速购速递 </div>
            </div>
        </div> 
    </footer>
    
</template>
<style src="bootstrap/dist/css/bootstrap.min.css"  scoped></style>
<style src="@/assets/css/style.css"  scoped></style>
<script >

export default{
    data(){
       
        var souimg = require("@/images/sous.png") 
        return{
            beianurl:'https://beian.miit.gov.cn/',
            souimg:souimg,
            footcourier:''
        }
    },
    methods:{
        getfootTracking(){
             
            if(this.footcourier == null || this.footcourier == ''){
                console.log('sda');
            }
            this.$router.push({ name: 'tracking', params: { courier: this.footcourier }})
        }
    }
}

</script >

<style>

</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue